import httpClient from '../../../../../../shared/libraries/httpClient';
import routes from '../../../../../../shared/routes';

const deactivateAffiliate = async affiliateId => {
  const { data } = await httpClient.put(
    routes.affiliates.deactivate({
      id: affiliateId,
    }),
  );

  return data;
};

export default deactivateAffiliate;
